import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UserInfoCard } from '@simOn/common/user-info-card-models';
import { API_URL } from '@simOn/utils/tokens';
import { Observable } from 'rxjs';
import {
  CreateEventDto,
  EventDto,
  EventFilteringOptions,
  EventListFiltersWithPage,
  EventPaginated,
  UpdateEventDto
} from '@simOn/event/element/models';

@Injectable({
  providedIn: 'root'
})
export class EventsApiService {
  private readonly http = inject(HttpClient);
  private readonly _apiUrl = inject(API_URL);

  getEventsPaginated(filters: Partial<EventListFiltersWithPage>): Observable<EventPaginated> {
    const body = {
      pageFilter: {
        pageNumber: filters.pageNumber,
        pageSize: filters.pageSize
      },
      eventFilter: {
        name: filters.name,
        apartmentIds: filters.apartmentIds,
        authorIds: filters.authorIds,
        assigneeIds: filters.assigneeIds,
        isOpen: filters.isOpen,
        editedAtFrom: filters.editedAtFrom,
        editedAtTo: filters.editedAtTo,
        nextEventTimeFrom: filters.nextEventTimeFrom,
        nextEventTimeTo: filters.nextEventTimeTo
      },
      eventSort: {
        sortBy: filters.sortBy,
        isAscending: filters.isAscending
      }
    };
    return this.http.post<EventPaginated>(`${this._apiUrl}/Events/GetEventsPaginated`, body);
  }

  getFilteringOptions(filters: Partial<EventListFiltersWithPage>): Observable<EventFilteringOptions> {
    const body = {
      name: filters.name,
      apartmentIds: filters.apartmentIds,
      authorIds: filters.authorIds,
      assigneeIds: filters.assigneeIds,
      isOpen: filters.isOpen,
      editedAtFrom: filters.editedAtFrom,
      editedAtTo: filters.editedAtTo,
      nextEventTimeFrom: filters.nextEventTimeFrom,
      nextEventTimeTo: filters.nextEventTimeTo
    };
    return this.http.post<EventFilteringOptions>(`${this._apiUrl}/Events/GetFilteringOptions`, body);
  }

  getEvents(): Observable<EventDto[]> {
    return this.http.get<EventDto[]>(`${this._apiUrl}/Events/GetEvents`);
  }

  getEvent(id: string): Observable<EventDto> {
    return this.http.get<EventDto>(`${this._apiUrl}/Events/GetEvent`, { params: { Id: id } });
  }

  getUsersAssignableToEvent(eventId?: string): Observable<UserInfoCard[]> {
    return this.http.get<UserInfoCard[]>(`${this._apiUrl}/Events/GetUsersAssignableToEvent`, {
      params: eventId ? { EventId: eventId } : {}
    });
  }

  createEvent(dto: CreateEventDto): Observable<EventDto> {
    return this.http.post<EventDto>(`${this._apiUrl}/Events/CreateEvent`, dto);
  }

  updateEvent(dto: UpdateEventDto): Observable<EventDto> {
    return this.http.put<EventDto>(`${this._apiUrl}/Events/UpdateEvent`, dto);
  }

  deleteEvent(id: string): Observable<void> {
    return this.http.delete<void>(`${this._apiUrl}/Events/DeleteEvent`, { body: { id } });
  }

  getRoomEventsCount(roomId: string): Observable<number> {
    return this.http.get<number>(`${this._apiUrl}/Events/GetRoomEventsCount`, {
      params: { RoomId: roomId }
    });
  }
}
